export type ColumnType =
  | 'BOOLEAN'
  | 'DATE'
  | 'DOUBLE'
  | 'FLOAT'
  | 'INT8'
  | 'INT16'
  | 'INT32'
  | 'INT64'
  | 'JSON'
  | 'STRING'
  | 'TIMESTAMP';

export const SORTS = ['ASC', 'DESC'] as const;
export type Sort = (typeof SORTS)[number];
